import { ErrorMessage, Field, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Oval } from 'react-loader-spinner';
import * as yup from 'yup'
import { enregistrercommission } from '../../services/parametres/commission';
import { rechercheroperateurparpays } from '../../services/parametres/operateur';
import { rechercherpays } from '../../services/parametres/pays';
import { rechercherallprestataires } from '../../services/prestataires/prestatairesRequest';
import { definirModeAffichage } from '../../services/parametres/affichage';
import { useTranslation } from 'react-i18next';

function AjoutAffichage(props) {
    const { t } = useTranslation();
    const [loading, setloading] = useState(false);
    const [messageError, setmessageError] = useState("");
    const [listePrestataire, setlistePrestataire] = useState([])
    let [prestataireSelected, setPrestataireSelected] = useState("");

    let initialValues = {
        id: props.data.id !== undefined ? props.data.id : "",
        prestataire_id: props.data.id !== undefined ? props.data.id : "",
        mode: props.data.mode !== undefined ? props.data.mode : ""
    }

    const validationValuesSchema = yup.object().shape({
        prestataire_id: yup.string().required(t('settings.displayMode.modal.errors.providerRequired')),
        mode: yup.string().required(t('settings.displayMode.modal.errors.modeRequired'))
    })

    const afficherPrestataires = () => {
        rechercherallprestataires().then((res) => {
            setlistePrestataire(res.data.donnee || res.data || []);
        })
    }

    const optionListPrestataire = listePrestataire.map((item, index) => (
        <option key={index} value={item.id}>{item.nom}</option>
    ));


    useEffect(() => {
        afficherPrestataires();
    }, []);

    const handleOnSubmitCommission = (values) => {
        setloading(true)
        definirModeAffichage(values).then((res) => {
            setloading(false);
            props.afficheraffichage();
            if (localStorage.getItem("role") !== "ROLE_ADMIN") {
                localStorage.setItem("display_mode", values.mode);
            }
            document.getElementById("fermer").click();
        }).catch((error) => {
            setloading(false);
            console.log(error.response.data);
            ((typeof error.response.data.donnee) === "string") && setmessageError(error.response.data.donnee);
        })
    }

    return (
        <div className="modal fade" id="ajoutaffichage" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content blueSkanpay">
                    <div className="modal-header text-white">
                        <h5 className="modal-title" id="staticBackdropLabel">{t('settings.displayMode.modal.title')}</h5>
                        <button type="button" className="bg-danger btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={validationValuesSchema}
                        onSubmit={handleOnSubmitCommission}
                    >
                        {({ resetForm }) => (

                            <Form>
                                <div className="modal-body bg-white">
                                    {messageError !== "" && <p className='text-danger'><i className='fa fa-exclamation-triangle'></i> {messageError}</p>}
                                    <div className='mb-3'>
                                        <label htmlFor="prestataire_id" className='form-label'>{t('settings.displayMode.modal.provider')}</label>
                                        <Field component="select" name="prestataire_id" className='form-select' disabled id="prestataire_id">
                                            <option value="">{t('settings.displayMode.modal.selectProviderPlaceholder')}</option>
                                            {optionListPrestataire}
                                        </Field>
                                        <p className='text-danger'><ErrorMessage name="prestataire_id"></ErrorMessage></p>
                                    </div>

                                    <div className='mb-3'>
                                        <label htmlFor="mode" className='form-label'>{t('settings.displayMode.modal.displayMode')}</label>
                                        <Field component="select" className='form-select' id='mode' name="mode" >
                                            <option value="">{t('settings.displayMode.modal.selectDisplayMode')}</option>
                                            <option value="TABLEAU">{t('settings.displayMode.modal.table')}</option>
                                            <option value="CARD">{t('settings.displayMode.modal.card')}</option>
                                        </Field>
                                        <p className='text-danger'><ErrorMessage name="mode"></ErrorMessage></p>
                                    </div>
                                </div>
                                <div className="modal-footer bg-white">
                                    <button type="button" id='fermer' onClick={() => { resetForm(); setPrestataireSelected(""); setmessageError("") }} className="btn btn-md btn-secondary" data-bs-dismiss="modal">{t('settings.displayMode.modal.close')}</button>
                                    <Oval width={30} height={30} color="#344b7b" visible={loading} />
                                    {!loading && <button type="submit" className="btn btn-md text-white blueSkanpay">{t('settings.displayMode.modal.save')}</button>}
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div >
    )
}

export default AjoutAffichage